import { AuthState } from '@okta/okta-auth-js';

import { PositionsOptionMonths } from '../../services/backend/PositionsOptionMonths';
import { useBaseApiClient } from '../useBaseApiClient';

export const usePositionsOptionMonths: () => PositionsOptionMonths<AuthState> = () => {
  return useBaseApiClient(PositionsOptionMonths);
};
